import { parseString } from './helpers'

export interface UserInterface {
  id: string
  username: string
  name: string
  email: string
  type: string
  description: string
  pin: string
  created_at: string
  updated_at: string
}

export interface UserResponseInterface {
  id: string
  username: string
  name: string
  email: string
  type: string
  description: string
  pin: string
  created_at: string
  updated_at: string
}

export function parseUserModel(response: UserResponseInterface): UserInterface {
  return {
    id: parseString(response?.id),
    username: parseString(response?.username),
    name: parseString(response?.name),
    email: parseString(response?.email),
    type: parseString(response?.type),
    description: parseString(response?.description),
    pin: parseString(response?.pin),
    created_at: parseString(response?.created_at),
    updated_at: parseString(response?.updated_at),
  }
}
